import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { appGeraet, startbildAusblenden } from "@/lib/app/schnittstelle";
import { appUmleitung, inUnsererApp } from "@/lib/app/umgebung";

/** Länger bleibt das Startbild nicht stehen, auch wenn die Seite noch lädt. */
const STARTBILD_HOECHSTENS_MS = 4000;

/** Steht die erste Seite? Ein Kopf, ein Formular, eine Hauptfläche oder die Hülle der neuen Ansicht, nicht nur der Kreisel. */
function seiteSteht(): boolean {
  return document.querySelector("#root main, #root h1, #root form, #root [data-app-huelle]") !== null;
}

/**
 * Startbild der App ausblenden, sobald die erste Seite steht (Sitzung A3). Wirkt nur in der App und nur, wenn das
 * Startbild in Web to Native auf „JS Trigger“ steht; sonst bleibt es bei der eingestellten Zeit.
 */
function useStartbildAusblenden() {
  useEffect(() => {
    if (!appGeraet()) return;
    const ende = Date.now() + STARTBILD_HOECHSTENS_MS;
    let zeit: number | null = null;
    const pruefen = () => {
      if (seiteSteht() || Date.now() > ende) {
        // Erst nach dem nächsten Bild, damit die Seite schon gezeichnet ist.
        requestAnimationFrame(() => startbildAusblenden());
        return;
      }
      zeit = window.setTimeout(pruefen, 100);
    };
    pruefen();
    return () => {
      if (zeit !== null) window.clearTimeout(zeit);
    };
  }, []);
}

/** Liegt eine Supabase-Sitzung im Speicher? Ohne Netz, damit die Weiche sofort entscheidet. */
function sitzungImSpeicher(): boolean {
  const suchen = (speicher: Storage) => {
    for (let i = 0; i < speicher.length; i++) {
      const k = speicher.key(i);
      if (k && /^sb-.*-auth-token$/.test(k) && speicher.getItem(k)) return true;
    }
    return false;
  };
  try {
    return suchen(window.localStorage) || suchen(window.sessionStorage);
  } catch {
    return false;
  }
}

/**
 * Die App kennt nur den Mitgliederbereich (Sitzung A1, Frage 398, `docs/strategie/app-konzept.md` §4.2): Öffentliche
 * Seiten mit Preisen und Kasse leiten in der App um. Im Browser tut die Weiche nichts. Welche Pfade bleiben, steht in
 * `src/lib/app/umgebung.ts` (`appUmleitung()`).
 */
export default function AppWeiche() {
  const { pathname } = useLocation();
  const [app] = useState(() => inUnsererApp());
  useStartbildAusblenden();
  if (!app) return null;
  const ziel = appUmleitung(pathname, sitzungImSpeicher());
  if (!ziel || ziel === pathname) return null;
  return <Navigate to={ziel} replace />;
}
